// Top 10 priority languages for therapists (US healthcare context)
export const TOP_LANGUAGES = [
  { name: "Spanish", native: "Español", flag: "ES" },
  { name: "Mandarin", native: "中文", flag: "CN" },
  { name: "Arabic", native: "العربية", flag: "AR" },
  { name: "French", native: "Français", flag: "FR" },
  { name: "Vietnamese", native: "Tiếng Việt", flag: "VN" },
  { name: "Tagalog", native: "Tagalog", flag: "PH" },
  { name: "Russian", native: "Русский", flag: "RU" },
  { name: "Korean", native: "한국어", flag: "KR" },
  { name: "Portuguese", native: "Português", flag: "PT" },
  { name: "Hindi", native: "हिन्दी", flag: "IN" },
];

export const ALL_LANGUAGES = [
  "English", "Spanish", "Mandarin", "Cantonese", "Arabic", "French", "German",
  "Italian", "Portuguese", "Russian", "Polish", "Ukrainian", "Romanian",
  "Greek", "Turkish", "Hebrew", "Persian (Farsi)", "Urdu", "Hindi", "Bengali",
  "Punjabi", "Tamil", "Telugu", "Gujarati", "Marathi", "Vietnamese", "Thai",
  "Khmer", "Lao", "Burmese", "Indonesian", "Malay", "Tagalog", "Japanese",
  "Korean", "Mongolian", "Swahili", "Amharic", "Somali", "Yoruba", "Igbo",
  "Hausa", "Zulu", "Afrikaans", "Dutch", "Swedish", "Norwegian", "Danish",
  "Finnish", "Czech", "Hungarian", "Bulgarian", "Serbian", "Croatian",
  "Albanian", "Armenian", "Georgian", "Haitian Creole", "Nepali", "Sinhala",
  "Pashto",
];
